import { type PaymentType as PayableType } from "@/api-v3";

/**
 * Anything PASS tags with Allowed Payable Types: a Payment Account
 * (`GET /payment-account`) or a Payment Method (`GET /payment-methods/ui`).
 */
export interface AllowedPayableTypesHolder {
  allowed_payable_types?: PayableType[] | null;
}

/**
 * Whether a Payment Account or Payment Method is Claim-capable for one Payable
 * Item kind.
 *
 * An absent list means PASS sent nothing, which its own fallback reads as all
 * four kinds, so it answers true. An empty list is a Spend Card and answers
 * false for every kind. Nothing at all is not a Payment Account, so it can
 * receive nothing.
 */
export const canReceivePayableType = (
  holder: AllowedPayableTypesHolder | null | undefined,
  payableType: PayableType
): boolean => {
  if (!holder) return false;

  const allowed = holder.allowed_payable_types;
  if (allowed == null) return true;

  return allowed.includes(payableType);
};
